import React, { Dispatch, FC, memo, SetStateAction } from "react";
import { useLocation } from "react-router-dom";
import {
  SecondaryNavBarItems,
  SecondaryNavigationBarStyled,
  SecondaryNavItemStyled,
  SecondaryNavTitleStyled,
} from "./styles";

interface SecondaryLinkItemType {
  id: string;
  text: string;
  link: string;
}

const linksConfig: Array<SecondaryLinkItemType> = [
  {
    id: "ota-setup",
    text: "Setup",
    link: "/ota",
  },
  {
    id: "ota-deployments",
    text: "Deployments",
    link: "/ota?view=deployments",
  },
  {
    id: "ota-stats",
    text: "Statistics",
    link: "/ota?view=stats",
  },
  {
    id: "ota-logs",
    text: "Logs",
    link: "/ota?view=logs",
  },
];

export const SecondaryNavBarOTA: FC<{
  isSecondaryNavOTAShown: boolean;
  setIsSecondaryNavOTAShown: Dispatch<SetStateAction<boolean>>;
}> = memo(({ isSecondaryNavOTAShown, setIsSecondaryNavOTAShown }) => {
  const { pathname, search } = useLocation();

  const isActive = (link: string) => {
    if (link.includes("?")) {
      const [path, query] = link.split("?");
      return pathname === path && search.includes(query);
    }
    return pathname === link && !search;
  };

  return (
    <SecondaryNavigationBarStyled
      isShown={isSecondaryNavOTAShown}
      onMouseEnter={() => {
        setIsSecondaryNavOTAShown(true);
      }}
      onMouseLeave={() => {
        setIsSecondaryNavOTAShown(false);
      }}
    >
      <SecondaryNavBarItems>
        {linksConfig.map(({ id, link, text }) => (
          <SecondaryNavItemStyled
            key={id}
            to={link}
            $active={isActive(link)}
            data-active={isActive(link)}
            onClick={() => {
              setIsSecondaryNavOTAShown(false);
            }}
          >
            <SecondaryNavTitleStyled>{text}</SecondaryNavTitleStyled>
          </SecondaryNavItemStyled>
        ))}
      </SecondaryNavBarItems>
    </SecondaryNavigationBarStyled>
  );
});
